import { I18n } from "@assets/strings";
import React, { JSX } from "react";
import styled from "styled-components";
import { Category } from "@domain/lms/category/category";
import { truncString } from "@utils/strings";
import { theme } from "@ui/styles/theme";

interface CategoryLabelProps extends React.HTMLAttributes<HTMLDivElement> {
	category: Category;
	bgColor?: string;
	fromRight?: boolean;
	renderIcons?: () => JSX.Element;
	isTitleTruncated?: boolean;
	isSmall?: boolean;
	max_temper?: number;
}
export const CategoryLabel: React.FC<CategoryLabelProps> = ({
	category,
	renderIcons,
	fromRight,
	bgColor = theme.colors.secondary,
	isTitleTruncated,
	isSmall,
	max_temper = 16,
	...htmlProps
}) => {
	// const max_temper = 16;
	// const truncatedText=
	return (
		<Container fromRight={fromRight} bgColor={bgColor} {...htmlProps}>
			{isSmall ? (
				<>
					<StyledIcons>{renderIcons?.()}</StyledIcons>
					{truncString(I18n.t(`category.${category}`), max_temper)}
				</>
			) : (
				<>
					{isTitleTruncated ? truncString(I18n.t(`category.${category}`), max_temper) : I18n.t(`category.${category}`)}
				</>
			)}
		</Container>
	);
};

const Container = styled.div.withConfig({
	shouldForwardProp: (prop) => !["bgColor", "fromRight", "small"].includes(prop),
})<{ bgColor?: string; fromRight?: boolean }>`
	background-color: ${({ bgColor }) => bgColor};
	border-radius: 50px;
	padding: 9px 12px 7px;
	${({ theme }) => theme.textStyles.label};
	color: ${({ theme }) => theme.colors.white};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 5px;
`;

const StyledIcons = styled.div`
	display: inline;
`;
